// extracted by mini-css-extract-plugin
export default {"container":"viewEdit_container__gMUrE","table":"viewEdit_table__bk2Vl","newRow":"viewEdit_newRow__lpgWW","newName":"viewEdit_newName__opEMq","input":"viewEdit_input__8nuNU"};